import { Chip, Stack, Typography } from "@mui/material";
import { QUOTE_STAGE_LABELS } from "../../constants/salesStages";

export const QUOTE_TYPES = {
  outbound: { label: "Casting Quote", flow: "main" },
  inbound: { label: "Vendor Quote", flow: "blue" },
};

export const items = [
  { id: "type", label: "Type" },
  { id: "quoteNumber", label: "Quote #" },
  { id: "partName", label: "Part" },
  { id: "stage", label: "Stage" },
  { id: "material", label: "Alloy" },
  { id: "price", label: "Price" },
  { id: "createdAt", label: "Created" },
];

export const keys = [
  {
    value: "type",
    CustomComponent: ({ item }) => {
      const type = item?.isVendorQuote
        ? QUOTE_TYPES.inbound
        : QUOTE_TYPES.outbound;
      return (
        <Chip
          variant="colorTag"
          flow={type.flow}
          label={type.label}
          size="small"
          sx={{ fontSize: 10 }}
        />
      );
    },
  },
  { value: "quoteNumber", defaultValue: "—" },
  {
    value: "partName",
    CustomComponent: ({ item }) => (
      <Stack direction="row" alignItems="center" gap="2px">
        <Typography variant="caption" fontSize={12}>
          {item?.partName || item?.part?.partName || "—"}
        </Typography>
        {(item?.partNumber || item?.part?.partNumber) && (
          <Typography variant="caption" fontSize={10} color="text.secondary">
            {item?.partNumber || item?.part?.partNumber}
          </Typography>
        )}
      </Stack>
    ),
  },
  {
    value: "stage",
    CustomComponent: ({ item }) => {
      const stage = QUOTE_STAGE_LABELS.find((s) => s.id === item?.stage);
      return stage ? (
        <Chip
          variant="colorTag"
          flow={stage.flow}
          label={stage.label}
          size="small"
          sx={{ fontSize: 10 }}
        />
      ) : null;
    },
  },
  {
    value: "material",
    CustomComponent: ({ item }) => (
      <Typography variant="caption" fontSize={12}>
        {item?.material?.name || "—"}
      </Typography>
    ),
  },
  { value: "price", isCurrency: true, defaultValue: 0 },
  { value: "createdAt", isDate: true },
];
